<template>
  <section class="navbar-container d-flex  align-items-center ">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-button variant="text" class="nav-link " @click="toggleVerticalMenuActive">
          <font-awesome-icon icon="fas fa-bars" size="lg" color="white" />
        </b-button>
      </li>
    </ul>

    <b-navbar-nav class="nav align-items-center ms-auto options-right-navbar flex-nowrap">
      <!-- <locale class="" /> -->
      <!-- <dark-Toggler class="d-md-block" /> -->
      <pages-dropdown class="lote" id="pages-dropdown" />
      <canjeador class="canjeador" id="canjeador" />
      <carrito-compra class="carrito-compra" id="carrito-compra" />
      <notification-dropdown class="notificador" id="notificador" />
      <user-dropdown id="user-dropdown" />
    </b-navbar-nav>

  </section>
</template>

<script setup>

// import DarkToggler from './components/DarkToggler.vue'
import NotificationDropdown from '@/components/notifications.vue'
import UserDropdown from './components/UserDropdown.vue'
import CarritoCompra from 'components/CarritoCompra.vue'
import Locale from './components/Locale.vue'
import PagesDropdown from 'components/PagesDropdown.vue'
import Canjeador from 'components/Canjeador.vue'

import useAuth from '@utils/useAuth.js'

import useAppConfig from '@/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import usuarioStore from '@/store/modules/usuario';
import useAppStore from '@/store/app';

const userStore = usuarioStore();
const app_store = useAppStore();

const props = defineProps({

  toggleVerticalMenuActive: {
    type: Function,
    default: () => { },
  },

  isVerticalMenuActive: {
    type: Boolean,
    required: false,
  },
})


const usuario = computed(() => userStore.usuario)

const isSwiping = inject('isSwiping')
const directionSwiping = inject('directionSwiping')
const coordsStart = inject('coordsStart');
const coordsEnd = inject('coordsEnd');
const { windowWidth } = toRefs(app_store)
const { skin } = useAppConfig()
const { appName, appLogoImage, applogoImageWhite, appLogoShort } = $themeConfig.app
const { isVerticalMenuActive } = toRefs(props)

const {
  is_loggin
} = useAuth();


const anchoSidebar = computed(() => app_store.windowWidth)

watch(isSwiping, (v) => {

  if (coordsStart.x >= 0 && coordsStart.x <= 50) {
    if (!isVerticalMenuActive.value && anchoSidebar.value <= 1200) {
      if (v && ['right'].includes(directionSwiping.value)) {
        props.toggleVerticalMenuActive()
      }
    } else if (isVerticalMenuActive.value && anchoSidebar.value <= 1200) {
      if (v && ['left'].includes(directionSwiping.value)) {
        props.toggleVerticalMenuActive()
      }
    }
  }
})

const logo = computed(() => appLogoShort);

</script>
<style lang="scss" scoped>
.selector-negocio .vs__dropdown-toggle {
  border-color: transparent !important;
}

.nav {

  .lote,
  .canjeador,
  .carrito-compra,
  .notificador {
    margin-right: 10px !important;
  }

  .options-right-navbar {
    min-width: 280px;
  }

  @media (min-width:768px) {
    .notificador {
      margin-right: 30px !important;
    }
  }

}
</style>